import Amplify from 'aws-amplify';
import { getAWSDynamicConfigByRegion,DEFAULT_REGION } from './configManager';

export default function amplifyConfigure(region=DEFAULT_REGION) {
    const awsConfig = getAWSDynamicConfigByRegion(region)  
    Amplify.configure(awsConfig);
  }